export default __webpack_public_path__ + "static/Honda Civic-b651c15ed18f280925699acf16872ed6.png";